//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    showWarning: { type: Boolean, default: false }
  },
  data: () => ({
    expanded: false
  }),
  computed: {
    classes () {
      return {
        LabelledLensTechSelect: true,
        'LabelledLensTechSelect--expanded': this.expanded
      }
    }
  },
  methods: {
    onClick (lensSku) {
      this.$emit('change', lensSku)
      if (this.expanded) this.expanded = false
    }
  }
}
